import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle,DropdownItem } from 'reactstrap';
import LoadingProgress from '../../../components/LoadingProgress'
import * as http from '../../../modules/http';
import * as UrlParamsManager from '../../../modules/UrlParamsManager';
import ReactQueryParams from 'react-query-params';
import {fetchCustomeraDataIfNeeded} from '../../../redux/actions/CustomersActions'


class ProductSelector extends ReactQueryParams {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            items:[],
            loading:false
        };
    }

    componentDidMount() {
        this.setState({items: this.props.items});
    }

    toggle() {

        /*if (!this.state.dropdownOpen){
            this.setState({loading:true});

            http.postToServer('affiliates_assets/' + this.props.endpoint,
                {},
                (response) =>
                {this.setState({items:response.data,loading:false})},
                () => console.log('error getting Products filter'));

        }*/
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    chooseItem(id){
        var queryParam = {};
        queryParam[this.props.queryParam] = id;
        this.setQueryParams(queryParam);

        this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
    }

    render() {
        let name = '';
        let item = this.queryParams[this.props.queryParam];

        if (!item){
            name = this.props.name;
        }
        else {
            let obj = this.state.items.find(e => e.value === parseInt(item));
            if(obj !== undefined) {
                name = obj.label;
            }
        }

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                >
                    <p>
                        {name}
                    <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                        <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                    </svg>
                    </p>

                </DropdownToggle>
                <DropdownMenu className='dropdown__menu'>
                    {this.state.loading &&
                    <DropdownItem>
                        <LoadingProgress></LoadingProgress>
                    </DropdownItem>
                    }

                    {!this.state.loading &&
                        this.state.items.map((currItem, index) =>
                            <DropdownItem key={index} onClick={()=>this.chooseItem(currItem.value)}>
                                {currItem.label}
                            </DropdownItem>
                        )
                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        //date: state.mainDashboard.date
    };
};

export default withRouter(connect(mapStateToProps)(ProductSelector))
